export default __webpack_public_path__ + "static/media/GroupAdd.80e0f25d.svg";